import { apiClient } from '../../gateways/api'
import type { FetchDeelnemerValuelists } from '../types/FetchDeelnemerValuelists'

export { fetchDeelnemerValuelists, initialState }

const initialState: FetchDeelnemerValuelists = {
  data: {
    netbeheerders: [],
    aannemers: [],
    disciplines: [],
    versies: [],
    gebieden: [],
  },
}

const fetchDeelnemerValuelists = async (): Promise<
  FetchDeelnemerValuelists['data']
> => {
  const { data } = await apiClient({
    url: '/rest/valuelist/deelnemer',
    method: 'GET',
  })
  return data
}
